const isInViewport = ($element) => {
  if (typeof window === 'undefined') {
    return false;
  }

  const rect = $element.getBoundingClientRect();

  return (
       rect.top >= 0
       && rect.left >= 0
       && rect.bottom <= (window.innerHeight || window.document.documentElement.clientHeight)
       && rect.right <= (window.innerWidth || window.document.documentElement.clientWidth)
  );
};

const toggleClassIfInViewport = ($item, inViewportClass, delay = 1) => () => {
  if (isInViewport($item)) {
    window.setTimeout(() => { $item.classList.add(inViewportClass); }, delay);
  } else {
    window.setTimeout(() => { $item.classList.remove(inViewportClass); }, delay);
  }
};

const delayedToggleClassWhenItemsInViewport = ($items, inViewportClass, animationDelay) => () => {
  let delay = 0;
  $items.filter($item => $item !== null && $item !== undefined).forEach(($item) => {
    toggleClassIfInViewport($item, inViewportClass, delay)();
    delay += animationDelay;
  });
};

export { isInViewport, toggleClassIfInViewport, delayedToggleClassWhenItemsInViewport };



// WEBPACK FOOTER //
// ./utils/helpers/viewport.js